/* eslint-disable */
// import requestRawDev from '@/utils/requestRawDev'
import requestDev from '@/utils/requestDev'
import requestRaw from '@/utils/requestRaw'
import { APIReportPHP, APICoreV2 } from '@/utils/servicesApi'
const qs = require('qs')
// export function detailTextReply(data) {
//     return requestRaw({
//         url: APICoreV2() + '/automation/reply-button/detail',
//         method: 'POST',
//         data: data // untuk array data post
//     })
// }
export function detailTextReplyForEdit(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/text-reply/detail_edit',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function deleteTextReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/text-reply/delete',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function detailTextReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/text-reply/detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function updateTextReplyPublish(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/text-reply/update_publish',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateTextReplyDraft(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/text-reply/update_draft',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function storeTextReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/text-reply/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function storeTextReplySilent(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/text-reply/stored',
        method: 'POST',
        data: data,
        silent: true
    })
}
export function listTextReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/text-reply/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listTextReplySilent(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/text-reply/list',
        method: 'POST',
        data: qs.stringify(params),
        silent: true
    })
}
export function actionDraftTextReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/text-reply/draft_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function actionPublishTextReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/text-reply/publish_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function actionDeleteTextReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/text-reply/delete_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function countPendingTransferSmartReply() {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply-transfer/count_pending',
        method: 'POST',
        // data: qs.stringify(params)
    })
}
export function deleteTransferAutoReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply-transfer/delete',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function activatedTransferAutoReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply-transfer/activated',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listReplyButtonsTransfer(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/reply-button-transfer/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function detailSmartReplyForEditTransfer(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply-transfer/detail_edit',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listSmartReplyTransfer(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply-transfer/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function transferAutoReplyValidation(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/transfer_validation',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function transferAutoReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/transfer',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function actionDraftQuickReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/quick-reply/draft_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function actionPublishQuickReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/quick-reply/publish_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function actionDeleteQuickReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/quick-reply/delete_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function actionDeleteCustomRules(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/custom-rules/delete_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function actionDeleteAutoReplyLink(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/reply-link/delete_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function actionDeleteAutoReplyButton(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/reply-button/delete_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function actionPublishSmartAutoReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/smart-reply/publish_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function actionDeleteSmartAutoReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/smart-reply/delete_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function actionDraftSmartAutoReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/smart-reply/draft_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function storeQuickReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/quick-reply/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function detailQuickReplyForEdit(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/quick-reply/detail_edit',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function deleteQuickReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/quick-reply/delete',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function detailQuickReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/quick-reply/detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateQuickReplyPublish(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/quick-reply/update_publish',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateQuickReplyDraft(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/quick-reply/update_draft',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listQuickReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/quick-reply/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function storeReplyLink(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/reply-link/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function detailReplyLink(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/reply-link/detail',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function deleteReplyLink(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/reply-link/delete',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function listReplyLink(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/reply-link/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function deleteCustomRules(headerId) {
    return requestRaw({
        url: APICoreV2() + '/automation/custom-rules/delete?header_id=' + headerId,
        method: 'GET',
    })
}
export function listCustomRules(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/custom-rules/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function storeCustomRules(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/custom-rules/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function detailCustomRules(headerId) {
    return requestRaw({
        url: APICoreV2() + '/automation/custom-rules/detail?header_id=' + headerId,
        method: 'GET',
    })
}
export function detailSmartReplyForEdit(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/detail_edit',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function deleteSmartReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/delete',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function deleteSmartReplySilent(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/delete',
        method: 'POST',
        data: qs.stringify(params),
        silent: true
    })
}
export function detailSmartReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateSmartReplyPublish(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/update_publish',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function updateSmartReplyDraft(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/update_draft',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function storeSmartReply(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/smart-reply/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function listSmartReply(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/smart-reply/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function storeAgentV2(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/agent-v2/stored',
        method: 'POST',
        data: data,
        silent: true
    })
}
export function activateAgentV2(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/agent-v2/activate',
        method: 'POST',
        data: data,
        silent: true
    })
}
export function deactivateAgentV2(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/agent-v2/deactivate',
        method: 'POST',
        data: data,
        silent: true
    })
}
export function deleteAgentV2(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/agent-v2/delete',
        method: 'POST',
        data: data,
        silent: true
    })
}
export function startAgentV2Simulation(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/agent-v2/simulation/start',
        method: 'POST',
        data: data,
        silent: true
    })
}
export function sendAgentV2Simulation(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/agent-v2/simulation/message',
        method: 'POST',
        data: data,
        silent: true
    })
}
export function resetAgentV2Simulation(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/agent-v2/simulation/reset',
        method: 'POST',
        data: data,
        silent: true
    })
}
export function storeReplyButtons(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/reply-button/stored',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function detailReplyButtons(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/reply-button/detail',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function deleteReplyButtons(data) {
    return requestRaw({
        url: APICoreV2() + '/automation/reply-button/delete',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function listReplyButtons(params) {
    return requestDev({
        url: APIReportPHP() + '/automation/reply-button/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}


// WEBPACK FOOTER //
// ./src/api/automation.js